import { URLS } from '../../../../constants';
import apiClient from '../../../client';
const claimAdjudicationApi = {
  getgroupCode: () =>
    apiClient
      .post(URLS.getGroupCode, { data: {} })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  getResonCode: () =>
    apiClient
      .post(URLS.getReasonCode, { data: {} })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  saveClaimAdjudication: ({
    claimId,
    type,
    adjudicationDate,
    serviceLineData,
    parentClaimId,
    adjudicationErrorCount,
  }: {
    adjudicationDate: any;
    claimId: any;
    serviceLineData: any;
    type: any;
    parentClaimId: any;
    adjudicationErrorCount: any;
  }) =>
    apiClient
      .post(URLS.saveClaimAndAdjustments, {
        data: {
          serviceLineData,
          claimId,
          adjudicationDate,
          type,
          parentClaimId,
          adjudicationErrorCount,
        },
      })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  getClaimAndServiceLine: ({
    id,
    type,
    parentClaimId,
  }: {
    id: any;
    type: any;
    parentClaimId: any;
  }) =>
    apiClient
      .post(URLS.getClaimAndServiceLine, {
        data: { id, type, parentClaimId },
      })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  deleteClaimAndServiceLine: ({
    id,
    type,
    adjudicationErrorCount,
  }: {
    id: any;
    type: any;
    adjudicationErrorCount: any;
  }) =>
    apiClient
      .post(URLS.deleteClaimAndServiceLine, {
        data: { id, type, adjudicationErrorCount },
      })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  saveToInbox: ({ claimId }: { claimId: any }) =>
    apiClient
      .post(URLS.saveSecondaryClaimToInbox, { data: { claimId } })
      .then(response => {
        return response;
      })
      .catch(() => {}),
  getErrorCount: ({ claimId }: { claimId: any }) =>
    apiClient
      .post(URLS.CobErrorCount, { data: { claimId } })
      .then(response => {
        return response;
      })
      .catch(() => {}),
};
export default claimAdjudicationApi;
